import 
{ 
    FETCH_EMPLOYEE_CATEGORY, REQUEST_EMPLOYEE_CATEGORY , CLEAR_CART, GET_HIRING,
    FETCH_OFFERS, REQUEST_OFFERS, LOGIN_USER, REMOVE_FROM_CART,
    OPEN_SIGNUP, CLOSE_SIGNUP, LOGOUT_USER, AUTHENTICATION_LOADING, 
    MOBILE_NAV, REQUEST_CLEANER , GET_CLEANER, ADD_TO_CART, APPLY_COUPON,
    REQUEST_CARPENTER, GET_CARPENTER, REQUEST_ELECTRICIAN , GET_ELECTRICIAN, GET_DETAIL_CART, CONTACT_US,
    GET_REVIEW, FETCH_EMPLOYEES, GET_BASIC_CART, DELETE_SERVICE_FROM_CART,
    FETCH_REVIEWS,  CREATE_REVIEW, REQUEST_REVIEWS, CREATE_REPLY, FETCH_FULL_SERVICE,
    REQUEST_FETCH_ORDER ,FETCH_ORDER, REQUEST_FETCH_ORDERS , FETCH_ORDERS, SEARCH_SERVICES, CLEAR_SEARCH,
    REQUEST_SERVICE_RECOMMANDATION_BASIC, FETCH_SERVICE_RECOMMANDATION_BASIC, REQUEST_SERVICE_RECOMMANDATION_DETAILED, FETCH_SERVICE_RECOMMANDATION_DETAILED,
    ADD_TO_CART_FROM_RECOMMENDED, REQUEST_ADD_TO_CART_FROM_RECOMMENDED, CHANGE_THEME, REFRESH_THEME, FETCH_CSRF, GET_USER_ERROR, GET_USER
}

from './Types';
import history from '../history'
import PythonApi from '../api/python'
import ReviewData from './review';

export const FetchEmpCategory = () => { 

    return (dispatch, getState) => {
        const state = getState()
        if (state.EmployeeCategory.data.length === 0){
            dispatch({type: REQUEST_EMPLOYEE_CATEGORY})
        }
        PythonApi.get('employee_category/')
        .then(response => {
            dispatch({type: FETCH_EMPLOYEE_CATEGORY, payload: response.data})
        })
        .catch(e => {
            console.log(e.response)
                dispatch({type: LOGOUT_USER, payload: false})
                PythonApi.get('employee_category/')
                .then(response => {
                    dispatch({type: FETCH_EMPLOYEE_CATEGORY, payload: response.data})
                })
        })

    }
}

export const fetchOffers = () => (dispatch, getState) => {
    const state = getState()
    if (state.EmployeeCategory.data.length === 0){
        dispatch({type: REQUEST_OFFERS})
    }
    PythonApi.get('coupons/')
    .then(response => dispatch({type: FETCH_OFFERS, payload: response.data}))
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get('coupons/')
            .then(response => {
                dispatch({type: FETCH_OFFERS, payload: response.data})
            })
    })
}   

export const openSignup = () => {
    return {
        type: OPEN_SIGNUP
    }
}

export const closeSignup = () => {
    return {
        type : CLOSE_SIGNUP
    }
}

// export const login = (loginCredintials, setFormError) => dispatch => {
//     PythonApi.post('api/token/', loginCredintials)
//     .then(response => {
//         localStorageObj._setToken(response.data.access, response.data.refresh)
//         getUser()
//         history.push('/')
//     })
//     .catch((error) => {
//         setFormError({error: true, message: "Invalid uservame or password."})
//     })
// }

export const login = (loginCredintials, setFormError, csrf) => dispatch => {
    PythonApi.post('account/login/v1/', loginCredintials, csrf)
    .then(response => {
        dispatch({type: GET_USER, payload: true})
        history.push('/')
        dispatch(fetchCSRF())
    })
    .catch((error) => {
        setFormError({error: true, message: "Invalid userame or password."})
    })
}


export const getUser = () => (dispatch, getState) => {
    const get_user = getState().shouldFetchUser
    if (get_user){
        dispatch({type: AUTHENTICATION_LOADING, payload: true})
        PythonApi.get('account/get_current_user/')
        .then(response => {
            response.data.loginStatus = true
            dispatch({type: LOGIN_USER, payload: response.data})
            dispatch({type: AUTHENTICATION_LOADING, payload: false})
        })
        .catch(e => {
                dispatch({type: AUTHENTICATION_LOADING, payload: false})
                dispatch({type: GET_USER_ERROR, payload: false})
        })
    }
    else{
        dispatch({type: AUTHENTICATION_LOADING, payload: false})
    }
}

export const fetchFullService = (slug) => dispatch => {
    PythonApi.get(`get_services/${slug}/`)
    .then(response => {
        dispatch({type: FETCH_FULL_SERVICE, payload: response.data})
    })
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get(`get_services/${slug}/`)
            .then(response => {
                dispatch({type: FETCH_FULL_SERVICE, payload: response.data})
            })
    })
}

export const fetchEmployees = (slug) => dispatch => {
    PythonApi.get(`get_employee/${slug}/`)
    .then(response => dispatch({type: FETCH_EMPLOYEES, payload: response.data}))
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get(`get_employee/${slug}/`)
            .then(response => {
                dispatch({type: FETCH_EMPLOYEES, payload: response.data})
            })
    })
}
export const fetchCategoryReviews = (slug) => dispatch => {
    dispatch({type: REQUEST_REVIEWS})
    PythonApi.get(`get_reviews/v2/${slug}/`)
    .then(response => dispatch({type: FETCH_REVIEWS, payload: response.data}))
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get(`get_reviews/${slug}/`)
            .then(response => {
                dispatch({type: FETCH_REVIEWS, payload: response.data})
            })
    })
}

export const createCategoryReview = (formData, urlSlug, isReply) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    const type = isReply ? CREATE_REPLY : CREATE_REVIEW
    PythonApi.post(`create_review/${urlSlug}/new/`, formData, csrfHeader)
    .then(response => dispatch({type: type, payload: response.data}))
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            dispatch(fetchCSRF())
    })
}
// export const logOut = () => {
//     localStorageObj._clearToken()
//     history.push('/')
//     return {
//         type: LOGOUT_USER,
//         payload: false
//     }
// }

export const logOut = (csrfHeader) => dispatch => {
    PythonApi.post('account/logout/v1/', {}, csrfHeader)
    .then(response => {
        console.log(response.data)
        // delete_cookie('get_user')
        history.push('/')
        dispatch({type: LOGOUT_USER, payload: false})
        dispatch(fetchCSRF())

    })
}

export const mobileNavToggle = (status) => {
    return {
        type: MOBILE_NAV,
        payload: status
    }
}

export const getCleanerSub = (id, slug) => dispatch => {
    dispatch({type: REQUEST_CLEANER})
    PythonApi.get(`subcategory/${id}/${slug}/`)
    .then((response) => dispatch({type: GET_CLEANER, payload: response.data}))
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get(`subcategory/${id}/${slug}/`)
            .then((response) => {
                dispatch({type: GET_CLEANER, payload: response.data})
            })
    })
}

export const getCarpenterSub = (id, slug) => dispatch => {
    dispatch({type: REQUEST_CARPENTER})
    PythonApi.get(`subcategory/${id}/${slug}/`)
    .then(response => dispatch({type: GET_CARPENTER, payload: response.data}))
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get(`subcategory/${id}/${slug}/`)
            .then(response => {
                dispatch({type: GET_CARPENTER, payload: response.data})
            })
    })
}
export const getElectrician = (id, slug) => dispatch => {
    dispatch({type: REQUEST_ELECTRICIAN})
    PythonApi.get(`subcategory/${id}/${slug}/`)
    .then(response => dispatch({type: GET_ELECTRICIAN, payload: response.data}))
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get(`subcategory/${id}/${slug}/`)
            .then(response => {
                dispatch({type: GET_ELECTRICIAN, payload: response.data})  
            })
    })
}
export const getReview = () => {
    return {
        type: GET_REVIEW,
        payload: ReviewData
    }
}

export const getBasicCart = () => dispatch => {
    PythonApi.get('cart/get/basic/')
    .then(response => dispatch({type: GET_BASIC_CART, payload: response.data}))
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get('cart/get/basic/')
            .then(response => {
                dispatch({type: GET_BASIC_CART, payload: response.data})
            })
    })
}

const HandleAddResponse = (response, dispatch, service_id, setCartCount, openCategoryModel, setModelText, updateCartReplacementItem) => {
    if (response.data.status && response.data.status === 'category_change'){
        // // Open Category Change Model
        setModelText(response.data.mssg)
        setCartCount(c => c - 1)
        updateCartReplacementItem(service_id)
        openCategoryModel()

    }   
    else{
        dispatch({type: ADD_TO_CART, payload: response.data})
        PythonApi.get('services/get-recommandation/basic/')
        .then(response => {
           const data = typeof response.data === "number" ? [response.data] : response.data
            dispatch({type: FETCH_SERVICE_RECOMMANDATION_BASIC, payload: data})
        })
        .catch(e => console.log("Add Endpoint for Recommander"))
        
    }
    dispatch(fetchCSRF())
}

// export const addToCart = (service_id, slug, openModel, setModelText, setCartCount, setReplacementCartItem) => dispatch => {
export const addToCart = (service_id, category, setCartCount, openCategoryModel, setModelText, setReplacementCartItem) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.post('cart/add/', {service_id: service_id, category: category}, csrfHeader)
    .then(response => {
        // HandleAddResponse(response, dispatch, openModel, setModelText, setCartCount, service_id, setReplacementCartItem)
        HandleAddResponse(response, dispatch, service_id, setCartCount, openCategoryModel, setModelText, setReplacementCartItem)
        
        
    })
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.post('cart/add/', {service_id: service_id, category: category})
            .then(response => {
            // HandleAddResponse(response, dispatch, openModel, setModelText, setCartCount, service_id, setReplacementCartItem)
            HandleAddResponse(response, dispatch, service_id, setCartCount, openCategoryModel, setModelText, setReplacementCartItem)
            })     
    })
    
}

export const removeFromCart = (service_id) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.post('cart/remove/', {service_id: service_id}, csrfHeader)
    .then(response => {
        dispatch({type: REMOVE_FROM_CART, payload: response.data})
        
    })
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.post('cart/remove/', {service_id: service_id})
            .then(response => dispatch({type: REMOVE_FROM_CART, payload: response.data}))
    })
    dispatch(fetchCSRF())
}

export const clearCart = () => dispatch => {
    PythonApi.get('cart/clear/')
    .then(response => {
        if (response.data.status === "ok"){
            dispatch({type: CLEAR_CART})
        }
    })
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get('cart/clear/')
            .then(response => {
                if (response.data.status === "ok"){
                    dispatch({type: CLEAR_CART})
                }
            })
    })
}
// action for replacing cart
export const replaceCart = (service_id, category, closeModel, incrementReplacedService) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.get('cart/clear/')
    .then(response => {
        if (response.data.status === "ok"){
            dispatch({type: CLEAR_CART})
            PythonApi.post('cart/add/', {service_id: service_id, category: category}, csrfHeader)
            .then(response => {
            HandleAddResponse(response, dispatch, service_id)
            closeModel()
            incrementReplacedService(c => c + 1)
        
            })
        }
    })
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get('cart/clear/')
            .then(response => {
                if (response.data.status === "ok"){
                    dispatch({type: CLEAR_CART})
                    PythonApi.post('cart/add/', {service_id: service_id, category: category}, csrfHeader)
                    .then(response => {
                    HandleAddResponse(response, dispatch, service_id)
                    closeModel()
                    incrementReplacedService(c => c + 1)
                    })
                }
            })
    })
}
export const getDetailCart = () => dispatch  =>{
    PythonApi.get('cart/get/detail/')
    .then(response => dispatch({type: GET_DETAIL_CART, payload: response.data}))
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.get('cart/get/detail/')
            .then(response => dispatch({type: GET_DETAIL_CART, payload: response.data}))
    })
}

export const deleteServiceFromCart = (service_id) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.post('cart/delete/', { service_id }, csrfHeader)
    .then(response => {
        dispatch({type: DELETE_SERVICE_FROM_CART, payload: response.data})
        
    })
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.post('cart/delete/', { service_id })
            .then(response => dispatch({type: DELETE_SERVICE_FROM_CART, payload: response.data}))
    })
    dispatch(fetchCSRF())
}

const handleCouponResponse = (response, setCouponState, dispatch) => {
    if (response.data.status === "invalid_coupon" || response.data.status === 'category_error'){
        setCouponState({loading: false, error: true, mssg: response.data.msg})
    }
    else{
        dispatch({type: APPLY_COUPON, payload: response.data})
        setCouponState({loading: false, error: false, mssg: "Coupon Applied!!"})
    }
    dispatch(fetchCSRF())
    
}
export const applyCoupon = (coupon_code, setCouponState) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.post('cart/coupon/apply/', {coupon_code: coupon_code}, csrfHeader)
    .then(response => {
        handleCouponResponse(response, setCouponState, dispatch)
    })
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            PythonApi.post('coupon/apply/', {coupon_code: coupon_code})
            .then(response => {
                handleCouponResponse(response, setCouponState, dispatch)
            })
    })
}

export const contactUs = (formData, setMessage, setLoading) => async (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    try{
        const response = await PythonApi.post('contact/send/', formData, csrfHeader)
        dispatch({type: CONTACT_US})
        setMessage(response.data)
        setLoading(false)
    }
    catch(e){

            dispatch({type: LOGOUT_USER, payload: false})
            const response = await PythonApi.post('contact/send/', formData, csrfHeader)
            dispatch({type: CONTACT_US})
            setMessage(response.data)
            setLoading(false)
        
    }
    dispatch(fetchCSRF())
}

const handleVerifyNumberResponse = (response, formValues, signUpSettings, FieldErrorRef, FieldErrorMssg, setFormError, setLoading) => {
    if (response.data.status === "ok"){
        // signUpSettings({otpSend: true, otpVerified: false, number: formValues.number, otp: response.data.otp, password: ""})
        signUpSettings(state => {
            return {...state, otpSend: true, number: formValues.number, otp: response.data.otp}
        })

    }
    else {
        FieldErrorRef.current = true
        FieldErrorMssg.current = response.data.msg
        setFormError(true)
    }
    setLoading(false)
    
}
export const verifyNumber = (formValues, signUpSettings, FieldErrorRef, FieldErrorMssg, setFormError, setLoading) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.post('account/create_user_account/', formValues, csrfHeader)
    .then(response => {
        handleVerifyNumberResponse(response, formValues, signUpSettings, FieldErrorRef, FieldErrorMssg, setFormError, setLoading)
    })
    .catch(e => {
        if (e?.response?.data?.status === "error"){ 
            handleVerifyNumberResponse(e.response, formValues, signUpSettings, FieldErrorRef, FieldErrorMssg, setFormError, setLoading)
        }
        else{
            console.log(e)
        }
        
    })
    dispatch(fetchCSRF())
}

const handleVerifyOtp = (response, formValues, signUpSettings, setOtpError, setLoading) => {
    if (response.data.status === 'error'){
        setOtpError({error: true, message: response.data.msg})
    }
    else{
        signUpSettings(state => {
            return {...state, otpVerified: true, password: formValues.password1}
        })
    }
    setLoading(false)
}
export const verifyOtp = (formValues, number, signUpSettings, setOtpError, setLoading) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.post(`account/create_user_account/verify/${number}/`, formValues, csrfHeader)
    .then(response => {
        handleVerifyOtp(response, formValues, signUpSettings, setOtpError, setLoading)
    })
    .catch(e => {
        if (e?.response?.data?.status === "error"){
            handleVerifyOtp(e.response, formValues, signUpSettings, setOtpError, setLoading)
        }
        else{
            console.log(e)
        }
        
    })
    dispatch(fetchCSRF())
}

const handleSignUpProfileUpdate = (response, closeModel, setLoading, setFormError, history, successPath, payButton) => {
    if (response.data.status === 'ok'){
        setLoading(false)
        closeModel()
        if (successPath){
            history.push(successPath)
        }
        if (payButton){
            payButton.current.click()
        }
        
    }
    else{
        setLoading(false)
        setFormError({status: 'true', msg: response.data.msg})
    }
}
export const signUpUpdateProfile = (formValues, number, closeModel, setLoading, setFormError, history, successPath, payButton) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.patch(`account/create_user_account/additional/v2/${number}/`, formValues, csrfHeader)
    .then(response => {
        handleSignUpProfileUpdate(response, closeModel, setLoading, setFormError, history, successPath, payButton)
    })
    .catch(e => {
        if (e?.response?.data?.status === "error"){
            handleSignUpProfileUpdate(e.response, closeModel, setLoading, setFormError, history, successPath, payButton)
        }
        else {
            console.log(e)
        }
        
    })
    dispatch(fetchCSRF())
}


const handleImageUpdate = (response, setSignUpstate, setImageUpdateError, setLoading) => {
    if (response.data.status === 'ok'){
        setSignUpstate(state => {
            setLoading(false)
            return {...state, profilePicUpdated: true}
        })
    }
    else{
        setImageUpdateError({error: true, 'message': response.data.message})
        setLoading(false)
        setSignUpstate(state => {
            return {...state, profilePicUpdated: false}
        })
    }
}

export const updateProfileImage = (image, number, password, setSignUpstate, setImageUpdateError, setLoading) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    let formValues = new FormData()
    if (image){
        formValues.append('image', image)
    }
    formValues.append('password', password)
    PythonApi.patch(`account/create_user_account/photo/v2/${number}/`, formValues, csrfHeader)
    .then(response => {
        handleImageUpdate(response, setSignUpstate, setImageUpdateError, setLoading)
    })
    .catch(e => {
        handleImageUpdate(e.response, setSignUpstate, setImageUpdateError, setLoading)
    })
    dispatch(fetchCSRF())
}

export const createRazorPayOrder = (setOrderState, razorPayHandleOrder, setLoading, setUpdateProfileModel) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.post('cart/create-razorpay-orders/', {}, csrfHeader)
    .then(response => {
        if (response.data.status === 'error' && response.data.msg ==='address_error'){
            // setOrderState(state => {
            //     return {...state, error: true, error_code: response.data.msg, order_status: 'fail'}
            // })
            setUpdateProfileModel(true)
        }
        else if (response.data.status === "ok"){
            setOrderState(state => {
                return {...state, error: false, error_code: null, order_status: 'success', order_detail: response.data['order_details'], order_receipt: response.data['receipt']}
            })
            const amount = response.data.order_details['amount']
            const receipt =response.data['receipt']
            const id = response.data.order_details['id']
            const user = response.data.user
            const notes = response.data.notes
            razorPayHandleOrder(amount, receipt, id, user, notes)
        }
        setLoading(false)
    })
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
         
    })
    dispatch(fetchCSRF())
}

export const createOrder = (razorPaySucessResponse, history, setError) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.post('cart/create-orders/', razorPaySucessResponse, csrfHeader)
    .then(response => {
        if (response.data.status === 'ok'){
            history.push(`order/${response.data['receipt']}/`)
        }
        else{
            setError(true)
        }
        
    })
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
    })
    dispatch(fetchCSRF())
}


export const retriveUserOrders = () => dispatch =>{
    dispatch({type: REQUEST_FETCH_ORDERS})
    PythonApi.get('cart/orders/user_order/')
    .then(response => dispatch({type: FETCH_ORDERS, payload: response.data}))
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            // PythonApi('orders/')
            // .then(response => dispatch({type: FETCH_ORDERS, payload: response.data}))
    })
}

export const retriveOrder = (order_id) => dispatch => {
    dispatch({type: REQUEST_FETCH_ORDER})
    PythonApi.get(`cart/orders/${order_id}`)
    .then(response => {
            dispatch({type: FETCH_ORDER, payload: response.data})
            
        })
    .catch(e => {
            dispatch({type: LOGOUT_USER, payload: false})
            // PythonApi.get(`orders/${order_id}`)
            // .then(response => dispatch({type: FETCH_ORDER, payload: response.data}))
    })
}

export const SearchService = (formValue) => dispatch => {
    PythonApi.get(`search/${formValue.query}/${formValue.city}/`)
    .then(response => {
        dispatch({type: SEARCH_SERVICES, payload: response.data})
    })
    .catch(e => {
        dispatch({type: LOGOUT_USER, payload: false})
        PythonApi.get(`search/${formValue.query}/${formValue.city}`)
        .then(response => dispatch({type: SEARCH_SERVICES, payload: response.data}))
        
    })
}
export const ClearSearch = () => {
    return {
        type: CLEAR_SEARCH,
        payload: []
    }
}

export const partnersRequest = (formData, setFormState) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    PythonApi.post('partner/request/', formData, csrfHeader)
    .then(response => {
        setFormState({loading: false, msg: response.data})
    })
    .catch(e => {
        setFormState({loading: false, msg: {status: 'error', message: 'Something is wrong with our backend please try again'}})

    })
    dispatch(fetchCSRF())
}
export const GetHiringCategory = () => dispatch => {
    PythonApi.get('category/hiring/')
    .then(response => dispatch({type: GET_HIRING, payload: response.data}))
    .catch(e => {
        dispatch({type: LOGOUT_USER, payload: false})
        PythonApi.get('category/hiring/')
        .then(response => dispatch({type: GET_HIRING, payload: response.data}))
    })
}

export const getBasicServiceRecommandation = () => dispatch => {
    dispatch({type: REQUEST_SERVICE_RECOMMANDATION_BASIC})
    PythonApi.get('cart/services/get-recommandation/basic/')
    .then(response => {
       const data = typeof response.data === "number" ? [response.data] : response.data
        dispatch({type: FETCH_SERVICE_RECOMMANDATION_BASIC, payload: data})
    })
    .catch(e => console.log("Add Endpoint for Recommander"))
}

export const getDetailServiceRecommandation = () => dispatch => {
    console.log("Calling Properly")
    dispatch({type: REQUEST_SERVICE_RECOMMANDATION_DETAILED})
    PythonApi.get('cart/services/get-recommandation/detail/')
    .then(response => {
       const data = typeof response.data === "number" ? [response.data] : response.data
        dispatch({type: FETCH_SERVICE_RECOMMANDATION_DETAILED, payload: data})
    })
    .catch(e => console.log("Add Endpoint for Recommander"))
}

export const addToCartFromRecommanded = (service_id, category) => (dispatch, getState) => {
    const state = getState()
    const csrfHeader = {headers: {'X-CSRFToken': state.csrf}}
    dispatch({ type: REQUEST_ADD_TO_CART_FROM_RECOMMENDED })
    PythonApi.post('cart/add/from_recommanded/', { service_id, category }, csrfHeader)
    .then(response => {
        dispatch({type: ADD_TO_CART_FROM_RECOMMENDED, payload: response.data})
        dispatch(fetchCSRF())
        console.log(response.data)
    })
}

export const changeTheme = (themeName) => {
    localStorage.setItem('theme', themeName)
    return {
        type: CHANGE_THEME,
        payload: themeName
    }
}

export const refreshTheme = () => {
    const theme = localStorage.getItem('theme')
    const payload = theme ? theme : "default";
    return {
        type: REFRESH_THEME,
        payload: payload
    }
}

export const fetchCSRF = () => dispatch => {
    PythonApi.get('account/get_csrf/')
    .then(response => {

        const csrf = response.headers['x-csrftoken']
        dispatch({
            type: FETCH_CSRF,
            payload: csrf
        })
    })
}